/* globals jQuery */
import 'fitvids.1.1.0'
import 'magnific-popup'

import './scroll-to-top.js'
import './slideshows.js'
import responsiveNav from './responsive-nav.jquery.js'
import accordion from './jquery.accordion.js'
import sectionTabs from './section-tabs.js'

(($) => {

    $.fn.responsiveNav = responsiveNav
    $.fn.accordion = accordion
    $.fn.sectionTabs = sectionTabs;

    const html = document.querySelector('html');
    html.classList.remove('no-js')
    html.classList.add('js');

    // Make nav menu nice & responsive
    $('nav.main-nav').responsiveNav({
        navType: 'offCanvas',
        closeOnOutsideClick: true
    });

    // Responsive Videos
    $('.rtecontent').fitVids();

    // Accordions
    $('dl.accordion').accordion();

    $('#categoryFilter').on('change',function(){
		var catLink = $(this).val();
		window.location = catLink;
	});

    //if the tab section exists and there is a tab list
    // locations
    if( $('.tabbed-section').length > 0 && $('.button-tabs').length > 0 ){
        $('.tabbed-section').sectionTabs();
    }

	//Video POPUP
    $('.js-open-video').magnificPopup({
		type:'iframe',
        disableOn: 700,
		mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        closeMarkup: '<button title="%title%" type="button" class="mfp-close">Close</button>'
	});


    /**
     * Social share links
     */
    $('.js-social-share').on("click", function(e) {
        // Prevent default anchor event
        e.preventDefault();

        // Set values for window
        let intWidth = '700';
        let intHeight = '500';
        let strResize = 'yes';
        let href = $(this).attr('href');

        // Set title and open popup with focus on it
        var strTitle = ((typeof $(this).attr('title') !== 'undefined') ? $(this).attr('title') : 'Social Share'),
            strParam = 'width=' + intWidth + ',height=' + intHeight + ',resizable=' + strResize,            
            objWindow = window.open(href, strTitle, strParam).focus();
    });

})(jQuery)
